import React, {
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Loader } from '@atoms';

import { MapContext } from '@contexts/map-context/map-context';

import classes from './map-loader.module.scss';

// TODO: do something with this ugly component
// TODO: maybe inject into <AtlasMap />? ¯\_(ツ)_/¯

type Props = PropsWithChildren<{}>;

// A component that shows loading instead of the map when the map is loading initially. It also shows loading overlay when the pointers are being loaded.
export const MapLoader = ({ children }: Props) => {
  const [layoutLoaded, setLayoutLoaded] = useState(false);
  const { loaded } = useContext(MapContext);

  const loadingTimeoutRef = useRef<NodeJS.Timer>();

  const onLoaded = useCallback(() => {
    setLayoutLoaded(true);
  }, []);

  useEffect(() => {
    if (loaded) {
      loadingTimeoutRef.current = setTimeout(onLoaded, 100);
    }
  }, [loaded]);

  const loading = useMemo(() => {
    return !(loaded && layoutLoaded);
  }, [loaded, layoutLoaded]);

  useEffect(
    () => () => {
      if (loadingTimeoutRef.current != undefined) {
        clearTimeout(loadingTimeoutRef.current);
      }
    },
    [],
  );

  return (
    <div className={classes.wrapper}>
      {children}

      {loading || !layoutLoaded ? (
        <div className={classes.layoutNotLoaded}>
          <Loader color="azure_radiance" loading />
        </div>
      ) : null}
    </div>
  );
};
